(function () {
    'use strict';

    const module = angular.module('uwAgenda.email');
    module.directive('emailReceiver', ['$filter', 'UserSearchService', 'SharedAgendaService', 'RoleType', EmailReceiverFn]);

    function EmailReceiverFn($filter, UserSearchService, SharedAgendaService, RoleType) {

        return {
            link: link,
            restrict: 'E',
            replace: true,
            templateUrl: '/app/email/overview/templates/email-receiver.template.html',
            scope: {
                selectedMails: '=',
                placeholder: '@',
                includeCurrentUser: '@?'
            }
        };

        function link(scope) {
            scope.selected = '';
            scope.mails = [];

            
            // function to remove a selectedMail
            scope.onRemove = function (email) {
                const item = scope.selectedMails.indexOf(email);
                if (item !== -1) {
                    scope.selectedMails.splice(item, 1);
                }
            };

            // function to add a selectedMail
            scope.onSelected = function (email) {
                if (email !== 'undefined' && email !== null && email !== "") {
                    scope.selectedMails.push(email.contactInfo);
                }
                scope.selected = '';
            };

            // function to validate email
            function validateEmail(email) {
                const pattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return pattern.test(email);
            }

            scope.onBlurAddEmail = function () {
                if (scope.selected && validateEmail(scope.selected)) {
                    scope.selectedMails.push(scope.selected);
                    scope.selected = '';
                } else{
                    scope.selected = '';
                }
            };

            scope.onKeyDown = function ($event) {
                // Enter (13) or Tab (9)
                if ($event.keyCode === 13 || $event.keyCode === 9) {
                    if (scope.selected && validateEmail(scope.selected)) {
                        scope.selectedMails.push(scope.selected);
                        scope.selected = ''; 
                    } else{
                        scope.selected = '';
                    }
                }
            };

            // push to maillist
            function appendMailsToScope(id, caption, mail) {
                scope.mails.push({
                    id: id,
                    caption: caption,
                    contactInfo: mail
                });
            }

            scope.refreshMails = function (searchValue) {
                scope.mails = [];

                if (searchValue !== "") {
                    // do search
                    UserSearchService.searchByEmail(searchValue).then(function (result) {
                        if (!scope.includeCurrentUser) {
                            // current user should not be selectable -> pin to self is not allowed
                            // $filter cant be used because of Not-Equal logic -> splice is faster
                            for (let i = 0; i < result.length; i++) {
                                // remove current user
                                if (result[i].id === SharedAgendaService.currentUser().id) {
                                    result.splice(i, 1);
                                }
                            }
                        }
                        // prepare mails 
                        angular.forEach(result, function (user) {
                            if (user.userContactInfo !== 'undefined' && user.userContactInfo !== null && user.userContactInfo !== "") {
                                appendMailsToScope(user.id, user.caption, user.userContactInfo.contactInfo);
                            }
                        });

                        // check if searchedMail found or is mal - append to preview list
                        const mailFound = $filter('filter')(scope.mails, {'contactInfo': searchValue}, true)[0];
                        if (!mailFound && validateEmail(searchValue)) {
                            appendMailsToScope(0, "New email", searchValue);
                        }
                    });
                } 
            };
            
        }
    }

})();